import { Fragment, useState } from 'react';
import {
    Button, Box, DialogTitle, Dialog, Typography, DialogContent,
    TextField, FormControl, Select, MenuItem, DialogContentText, DialogActions, OutlinedInput, FormHelperText, InputLabel, FilledInput, List, ListItem, makeStyles, ListItemText, ListItemIcon, Tab, Tabs, Autocomplete,
    LinearProgress, styled, Paper, Accordion, AccordionSummary, AccordionDetails
} from '@mui/material';
import { FormContainer, TextFieldElement, AutocompleteElement, SelectElement, SliderElement } from 'react-hook-form-mui';
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../../../redux/reducers/authSlice"
import { DataGrid, GridToolbar, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarFilterButton, GridToolbarExport, GridToolbarQuickFilterProps, GridToolbarColumnsButton } from "@mui/x-data-grid";
import { useGetEdificiosQuery, useAddEdificioMutation, useEditEdificioMutation, useDeleteEdificiosMutation } from "../../../redux/reducers/edificiosSlice";
import { useGetDepartamentosQuery, useAddDepartamentoMutation, useEditDepartamentoMutation, useClasesContratosQuery, useDeleteDepartamentosMutation } from "../../../redux/reducers/departamentosSlice";
import { useGetCanalesAdjudicacionQuery } from "../../../redux/reducers/canalesAdjudicacionSlice"
import { useGetAdjudicacionesQuery, useEditAdjudicacionesMutation, useGetCanalesAdjudicacionesQuery, useGetAdjudicacionesByIdQuery, useAddAdjudicacionesMutation, useDeleteAdjudicacionesMutation } from "../../../redux/reducers/adjudicacionesSlice";
import IconButton from '@mui/material/IconButton';
import CreateIcon from '@mui/icons-material/Create';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import ApartmentRounded from '@mui/icons-material/ApartmentRounded'
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import Grid from '@mui/material/Grid';
import { removeEmpty } from "../../../lib/utils/index.js";
import { useEffect } from 'react';
import { v4 as uuid } from 'uuid';
import theme from '../../../theme.js';

export default function EdificiosCat() {
    const currentUser = useSelector(selectCurrentUser);
    let esEjecutivoCuentasUser = currentUser.roles.map(r => r === 'Ejecutivo de Cuentas')

    const { data: edificios, isSuccess, isError, error, isLoading } = useGetEdificiosQuery();
    const { data: departamentos, isSuccess: departamentosIsSucces } = useGetDepartamentosQuery();
    const { data: clasesContratos, isSuccess: clasesContratosIsSucces } = useClasesContratosQuery();
    const { data: adjudicaciones, isSuccess: adjudicacionesIsSucces } = useGetAdjudicacionesQuery();
    const { data: canalesAdjudicacion, isSuccess: canalesAdjudicacionIsSucces } = useGetCanalesAdjudicacionQuery();

    const [buildingMoreDetail, setBuildingMoreDetail] = useState([]); //A: cuando se hace click en el boton de mas detalles, se guarda el edificio en esta variable
    const [showBuildingMoreDetail, setShowBuildingMoreDetail] = useState(false);
    const openMoreDetail = () => setShowBuildingMoreDetail(true);
    const closeMoreDetail = () => setShowBuildingMoreDetail(false);

    const Header = (props) => {
        return (<Fragment>
            <Typography variant="h5" component="div" sx={{ minWidth: 275, margin: '10px' }}>{<ApartmentRounded></ApartmentRounded>} Edificios</Typography>
            {isLoading && <p>Cargando</p>}
            {isError && <p>Ha ocurrido un error</p>}
        </Fragment>);
    };
    const EdificiosTable = (props) => {
        const [selectedRows, setSelectedRows] = useState([]);
        let rows = Object.values(edificios?.entities || []);
        function getCantDptos(id) {
            let dptosDeEdificio = Object.values(departamentos?.entities || {}).filter(dpto => dpto.edificioId === parseInt(id));
            return dptosDeEdificio.length
        }
        const columns = [
            { field: 'edificioId', headerName: 'ID', flex: 16 },
            { field: 'calle', headerName: 'Calle', flex: 17 },
            { field: 'altura', headerName: 'Altura', flex: 16 },
            { field: 'cantidadPisos', headerName: 'Cantidad de pisos', flex: 16 },
            { field: 'cantidadDepartamentos', headerName: 'Cantidad de departamentos', flex: 16, valueGetter: v => getCantDptos(v.row.edificioId) },
            {
                headerName: 'Departamentos', flex: 16, renderCell: v => <Button component="button" variant="contained" size="small" onClick={() => {
                    setBuildingMoreDetail(v.row)
                    openMoreDetail()
                }}> Ver </Button >
            },
        ];

        const BtnBar = (props) => {
            // constantes, variable y funciones de los edificios
            const [showNuevoEdificioForm, setShowNuevoEdificioForm] = useState(false);
            const openForm = () => setShowNuevoEdificioForm(true);
            const closeForm = () => setShowNuevoEdificioForm(false);

            const [showBorrarEdificioForm, setShowBorrarEdificioForm] = useState(false);
            const [estamosBorrando, setEstamosBorrando] = useState(null);
            const openDeleteForm = () => setShowBorrarEdificioForm(true);
            const closeDeleteForm = () => setShowBorrarEdificioForm(false);

            let edificioDflt = {
                distritoId: 1,
                calle: '',
                altura: '',
                cantidadPisos: '',
                departamentos: [],
            }
            const [estamosEditando, setEstamosEditando] = useState(edificioDflt);
            const [creando, setCreando] = useState(false);


            function handleAdd() {
                setCreando(true);
                setEstamosEditando(edificioDflt);
                openForm();
            }

            function handleEdit() {
                setCreando(false)
                let edificioSeleccionado = edificios.entities[selectedRows[0]];
                if (edificioSeleccionado) {
                    setEstamosEditando({ ...edificioSeleccionado });
                    openForm();
                }
            }

            function handleDeleteSubmit() {
                let edificiosSeleccionados = edificios.entities[selectedRows.map(id => id === parseInt(id))];
                setEstamosBorrando(edificiosSeleccionados);
                openDeleteForm();
            };
            const BorrarEdificioForm = (props) => {
                const [deleteEdificios] = useDeleteEdificiosMutation();
                let edificios = selectedRows.map(id => parseInt(id)).sort();
                let sonEdificios = edificios.length !== 1 && edificios.length > 0;

                const borrar = () => {
                    deleteEdificios(selectedRows.map(id => parseInt(id))).unwrap()
                        .then(console.log)
                        .catch(console.log)
                    setEstamosBorrando(false);
                    setSelectedRows([]);
                    closeForm();
                }
                return (
                    <Fragment>
                        <Dialog onClose={closeDeleteForm} open={showBorrarEdificioForm} maxWidth="xs">
                            <DialogTitle>{sonEdificios ? 'Borrando Edificios' : 'Borrando Edificio'}</DialogTitle>
                            <DialogContent dividers>
                                <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            {sonEdificios ? '¿Quiere borrar los edificios seleccionados?' : '¿Quiere borrar el edificio seleccionado?'}
                                        </Grid>
                                        <List>
                                            {edificios.map(id => (
                                                <ListItem key={'ed' + edificios[id]} >
                                                    <ListItemIcon><ApartmentRounded></ApartmentRounded></ListItemIcon>
                                                    <ListItemText>{`ID:  ${id}`}</ListItemText>
                                                </ListItem>))}
                                        </List>
                                        <Grid item xs={12}>

                                            <div style={{ marginTop: '10px', marginLeft: '5px' }}>
                                                <Button variant="contained" onClick={borrar} sx={{ marginRight: '5px' }}>{"Aceptar"}</Button>
                                                <Button variant="outlined" onClick={closeDeleteForm}>{"Cancelar"}</Button>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </DialogContent>
                        </Dialog>
                    </Fragment>
                )

            }
            //funciones variables y states de Dptos
            const [editDepartamento] = useEditDepartamentoMutation();
            const [deleteDepartamentos] = useDeleteDepartamentosMutation();
            const [addDepartamento] = useAddDepartamentoMutation();

            const getOptionsClasesContratos = () => {
                return clasesContratos.map(cc => ({ id: cc.claseContratoId, label: cc.descripcion }))
            };

            const NuevoEdificioForm = (props) => {
                // States Edificio
                const [editEdificio] = useEditEdificioMutation();
                const [addEdificio] = useAddEdificioMutation();
                const [errores, setErrores] = useState([]);
                let edificioAux = { ...props.edificio };
                const [edificio, setEdificio] = useState({ ...edificioAux });

                // States y variables de Departamentos 
                let dptoDflt = {
                    claseContratoId: '',
                    m2: '',
                    piso: '',
                    uniFuncional: '',
                    edificioId: props.edificio.edificioId ? props.edificioId : ''
                };
                let dptosDeEdificio = Object.values(departamentos?.entities || {}).filter(dpto => dpto.edificioId === props.edificio.edificioId);
                const [dptos, setDptos] = useState(dptosDeEdificio ? dptosDeEdificio : [])
                let newDptos = []
                const [deleteDptos, setDeleteDptos] = useState([])

                // Funciones Para Manejar departementos
                function handleDeleteDpto(id) { //Borra departamentos de la lista no de la DB
                    setDeleteDptos([...deleteDptos, id]);
                    setDptos([...dptos].filter(dpto => dpto.departamentoId !== id));
                };
                const handleDptoChange = (value, index, propiedad) => {

                    newDptos = [...dptos];

                    if (newDptos[index] === null || newDptos[index] === undefined) newDptos[index] = {};
                    if (propiedad === 1) { newDptos[index] = { ...newDptos[index], claseContratoId: parseInt(value) } }
                    if (propiedad === 2) { newDptos[index] = { ...newDptos[index], m2: parseInt(value) } }
                    if (propiedad === 3) { newDptos[index] = { ...newDptos[index], piso: parseInt(value) } }
                    if (propiedad === 4) { newDptos[index] = { ...newDptos[index], uniFuncional: value.toString() } }

                    setDptos(newDptos);
                }

                //Función que se llama al apretar el botón 'Aceptar' y raliza los cambios en la bd.
                function handleSubmit() {
                    let estamosEditando = props.edificio.edificioId;
                    setErrores([]);
                    let huboError = false; //FIX: setState es una funcion asincronica, no se puede usar como condicion la logintud del array errores

                    function isEmpty(obj) {
                        for (var key in obj) {
                            if (key !== 'fecha' && obj[key] !== "") {
                                return false;
                            }
                        }
                        return true;
                    }

                    if (isEmpty(edificio)) {
                        setErrores(['Debe completar al menos un campo']);
                        huboError = true;
                    }
                    if (creando) {
                        dptos.forEach(d => { edificio.departamentos.push(d) })
                    }
                    if (isEmpty(edificio)) {
                        setErrores(['Debe completar al menos un campo']);
                        huboError = true;
                    }

                    if (estamosEditando) {
                        edificio.edificioId = props.edificio.edificioId
                        editEdificio(edificio).unwrap()
                            .then(console.log)
                            .catch(console.log);
                    } else {
                        removeEmpty(edificio);
                        addEdificio(edificio).unwrap()
                            .then(console.log)
                            .catch(console.log);
                    }
                    // Acciones departamentos
                    console.log('Este ES EL DPTO Cuando se va a submit :  ')
                    console.log(dptos)
                    if (estamosEditando) {
                        //Borrar Dptos
                        setDeleteDptos(deleteDptos.filter(dpto => {
                            return typeof dpto.departamentoId !== 'string'
                        }));
                        deleteDepartamentos(deleteDptos.map(id => parseInt(id))).unwrap()
                            .then(console.log)
                            .catch(console.log)
                        setDeleteDptos([])
                        //Agregar nuevos departamentos
                        let newDptos = dptos.filter(dpto => {
                            return typeof dpto.departamentoId === 'string'
                        })
                        newDptos.map(dpto => {
                            delete dpto.departamentoId
                        });
                        console.log('ESTO SON LOS DPTOS NUEVOS CUANDO SE LE SACA EL ID')
                        console.log(newDptos)
                        newDptos.forEach(dpto => {
                            if (isEmpty(dpto)) {
                                setErrores(['Debe completar al menos un campo del departamento:']);
                                huboError = true;
                            } else {
                                removeEmpty(dpto);
                                addDepartamento(dpto).unwrap()
                                    .then(console.log)
                                    .catch(console.log);
                            }
                        });
                        //Editar Departamentos
                        setDptos(dptos.filter(dpto => { return typeof dpto.departamentoId !== 'string' }));
                        console.log('ESTO SON LOS DPTOS QUE SE EDITAN')
                        console.log(dptos)
                        dptos.forEach(dpto => {
                            if (isEmpty(dpto)) {
                                setErrores(['Debe completar al menos un campo del departamento:']);
                                huboError = true;
                            }
                            if (estamosEditando) {
                                editDepartamento(dpto).unwrap()
                                    .then(console.log)
                                    .catch(console.log);
                            }
                        });
                    }

                };
                return (
                    <Fragment>
                        <Dialog onClose={closeForm} open={showNuevoEdificioForm} maxWidth='md'>
                            <DialogTitle>{creando ? 'Crear nuevo edificio' : `Editar edificio ID: ${props.edificio.edificioId}`}</DialogTitle>
                            <DialogContent dividers>
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', with: 900 }} >
                                    <div >
                                        <FormContainer defaultValues={{ ...edificio }} onSuccess={handleSubmit}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={1} style={{ 'paddingTop': '40px' }}><ApartmentRounded></ApartmentRounded></Grid>
                                                <Grid item xs={3} style={{ 'paddingTop': '20px' }}>
                                                    <FormControl variant="outlined" >
                                                        <OutlinedInput
                                                            value={edificio.calle}
                                                            onChange={e => setEdificio({ ...edificio, calle: e.target.value.toString() })}
                                                            id="outlined-adornment-weight"
                                                            type="string"
                                                        />
                                                        <FormHelperText id="outlined-weight-helper-text">Calle</FormHelperText>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={3} style={{ 'paddingTop': '20px' }}>
                                                    <FormControl variant="outlined">
                                                        <OutlinedInput
                                                            value={edificio.altura}
                                                            onChange={e => setEdificio({ ...edificio, altura: parseInt(e.target.value) })}
                                                            id="outlined-adornment-weight"
                                                            type="number"
                                                        />
                                                        <FormHelperText id="outlined-weight-helper-text">Numeración</FormHelperText>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={3} style={{ 'paddingTop': '20px' }}>
                                                    <FormControl variant="outlined">
                                                        <OutlinedInput
                                                            value={edificio.cantidadPisos}
                                                            onChange={e => setEdificio({ ...edificio, cantidadPisos: parseInt(e.target.value) })}
                                                            id="outlined-adornment-weight"
                                                            type="number"
                                                        />
                                                        <FormHelperText id="outlined-weight-helper-text">Cantidad de pisos</FormHelperText>
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                            <Grid dividers xs={12} style={{ 'padding': '0.5rem' }}>
                                                <Typography>Departamentos</Typography>
                                            </Grid>
                                            <Fragment>
                                                {dptos.map((dpto, i) => {
                                                    return (
                                                        <FormContainer defaultValues={{ ...dpto }}>

                                                            <Grid container spacing={0.5} dividers="true" key={'dpto' + dpto.departamentoId} >
                                                                <Grid item xs={2} style={{ 'paddingTop': '20px', 'marginRight': '35px' }}>
                                                                    <List>
                                                                        <ListItem>
                                                                            <ListItemIcon><HomeRoundedIcon></HomeRoundedIcon></ListItemIcon>
                                                                            <ListItemText>{typeof dpto.departamentoId !== 'string' ? `ID:  ${dpto.departamentoId}` : `Nuevo Dpto`}</ListItemText>
                                                                        </ListItem>
                                                                    </List>
                                                                </Grid>
                                                                <Grid item xs={2} style={{ 'paddingTop': '28px', 'marginLeft': '15px' }}>
                                                                    <SelectElement
                                                                        sx={{ width: '100%' }}
                                                                        label="Clase Contrato"
                                                                        name={'claseContratoId'}
                                                                        value={dpto.claseContratoId}
                                                                        required
                                                                        options={getOptionsClasesContratos()}
                                                                        onChange={(value) => { handleDptoChange(value, i, 1) }}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={2} style={{ 'paddingTop': '20px' }}>
                                                                    <FormControl sx={{ m: 1 }} variant="outlined">
                                                                        <OutlinedInput
                                                                            value={dpto.m2}
                                                                            onChange={(e, value) => { handleDptoChange(e.target.value, i, 2) }}
                                                                            id="outlined-adornment-weight"
                                                                            type="number"
                                                                        />
                                                                        <FormHelperText id="outlined-weight-helper-text">m2</FormHelperText>
                                                                    </FormControl>
                                                                </Grid>
                                                                <Grid item xs={2} style={{ 'paddingTop': '20px' }}>
                                                                    <FormControl sx={{ m: 1 }} variant="outlined">
                                                                        <OutlinedInput
                                                                            value={dpto.piso}
                                                                            onChange={(e, value) => { handleDptoChange(e.target.value, i, 3) }}
                                                                            id="outlined-adornment-weight"
                                                                            type="number"
                                                                        />
                                                                        <FormHelperText id="outlined-weight-helper-text">Piso</FormHelperText>
                                                                    </FormControl>
                                                                </Grid>
                                                                <Grid item xs={2} style={{ 'paddingTop': '20px' }}>
                                                                    <FormControl sx={{ m: 1 }} variant="outlined">
                                                                        <OutlinedInput
                                                                            value={dpto.uniFuncional}
                                                                            onChange={(e, value) => { handleDptoChange(e.target.value, i, 4) }}
                                                                            id="outlined-adornment-weight"
                                                                            type="string"
                                                                        />
                                                                        <FormHelperText id="outlined-weight-helper-text">U.F.</FormHelperText>
                                                                    </FormControl>
                                                                </Grid>
                                                                <Grid item xs={1} style={{ 'paddingTop': '30px' }}>
                                                                    <IconButton className="mb-3" variant="contained" color='danger' onClick={() => handleDeleteDpto(dpto.departamentoId)}><DeleteIcon /></IconButton >
                                                                </Grid>
                                                            </Grid>
                                                        </FormContainer>
                                                    )
                                                })}
                                                <Grid item xs={12} style={{ padding: '0.5rrem' }}>
                                                    <Button onClick={() => setDptos([...dptos, { ...dptoDflt, departamentoId: uuid(), edificioId: props.edificio.edificioId }])}>Agregar</Button>
                                                </Grid>
                                            </Fragment>
                                        </FormContainer>
                                    </div>

                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sx={{ color: 'error.main' }}>
                                            {errores.length > 0 && errores.map((error, i) => <p style={{ marginLeft: '8px' }} key={'err' + i}>- {error}</p>)}
                                        </Grid>

                                        <Grid item xs={12}>
                                            <div style={{ marginTop: '10px', marginLeft: '5px' }}>
                                                <Button variant="contained" onClick={handleSubmit} sx={{ marginRight: '5px' }}>{"Aceptar"}</Button>
                                                <Button variant="outlined" onClick={closeForm}>{"Cancelar"}</Button>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </DialogContent>
                        </Dialog>
                    </Fragment >
                )
            }
            const BuildingMoreDetailsModal = (props) => {
                let edificioId = props.edificio.edificioId;
                let dptosDeEdificio = Object.values(departamentos?.entities || {}).filter(dpto => dpto.edificioId === edificioId);
                let adjDptos = Object.values(adjudicaciones?.entities || {}).filter(a => dptosDeEdificio.map(d => d.departamentoId).includes(a.departamentoId))

                const getEstado = (dptoId) => {
                    if (adjDptos.map(a => a.departamentoId).includes(dptoId)) {
                        return 'Adjudicado'
                    } else {
                        return 'No adjudicado'
                    }
                };
                const getDescripcionClase = (claseId) => clasesContratos.find(c => c.claseContratoId === parseInt(claseId))?.descripcion;
                const columnsDepartamentos = [
                    { field: 'departamentoId', headerName: 'ID', flex: 2 },
                    { field: 'descripcion', headerName: 'Descripción de contrato', flex: 24, valueGetter: v => getDescripcionClase(v.row.claseContratoId) },
                    { field: 'm2', headerName: 'm2', flex: 12 },
                    { field: 'piso', headerName: 'Piso del edificio', flex: 12 },
                    { field: 'uniFuncional', headerName: 'Unidad funcional', flex: 12 },
                    {
                        headerName: 'Estado de licitación', flex: 16, valueGetter: v => getEstado(v.row.departamentoId)
                    }
                    //{(adjDptos.map(a => a.departamentoId).includes(v.row.departamentoId)) ? `Adjudicado` : `No adjudicado`}
                    // <Button component="button" disabled={!(adjDptos.map(a => a.departamentoId).includes(v.row.departamentoId))} variant="contained" size="small" onClick={() => {}}> Adjudicado </Button >
                    //},
                ];

                // States y variables de Departamentos 
                // let dptosDeEdificio = Object.values(departamentos?.entities || {}).filter(dpto => dpto.edificioId === edificioId);
                const [selectedRowsDptos, setSelectedRowsDptos] = useState([]);
                let rowsDptos = Object.values(dptosDeEdificio || []);
                let dptoDflt = {
                    claseContratoId: '',
                    m2: '',
                    piso: '',
                    uniFuncional: '',
                    edificioId: edificioId ? edificioId : ''
                };

                const DptosBtnBar = (props) => {
                    const [dpto, setDpto] = useState([])

                    const [creando, setCreando] = useState([false])
                    const [deleteDptos, setDeleteDptos] = useState([])
                    const [showNuevoDptoForm, setShowNuevoDptoForm] = useState(false);
                    const openForm = () => setShowNuevoDptoForm(true);
                    const closeForm = () => setShowNuevoDptoForm(false);

                    const [showBorrarDptoForm, setShowBorrarDptoForm] = useState(false);
                    const [estamosBorrando, setEstamosBorrando] = useState(null);
                    const openDeleteForm = () => setShowBorrarDptoForm(true);
                    const closeDeleteForm = () => setShowBorrarDptoForm(false);

                    // Funciones Para Manejar departementos

                    function handleAddDpto() {
                        setCreando(true);
                        setDpto(dptoDflt);
                        openForm();
                    }

                    function handleEditDpto() {
                        setCreando(false)
                        let dptoSelect = departamentos.entities[selectedRowsDptos[0]];
                        console.log(dptoSelect)
                        if (dptoSelect) {
                            setDpto({ ...dptoSelect });
                            openForm();
                        }
                    }

                    function handleDeleteSubmitDpto() {
                        let dptosSelect = departamentos.entities[selectedRowsDptos.map(id => id === parseInt(id))];
                        setDeleteDptos(dptosSelect);
                        openDeleteForm();
                    };
                    const BorrarDptoForm = (props) => {
                        let dptos = selectedRowsDptos.map(id => parseInt(id)).sort();
                        let sonDptos = dptos.length !== 1 && dptos.length > 0;

                        const borrar = () => {
                            deleteDepartamentos(selectedRowsDptos.map(id => parseInt(id))).unwrap()
                                .then(console.log)
                                .catch(console.log)
                            setEstamosBorrando(false);
                            setSelectedRowsDptos([]);
                            closeForm();
                        }
                        return (
                            <Fragment>
                                <Dialog onClose={closeDeleteForm} open={showBorrarDptoForm} maxWidth="xs">
                                    <DialogTitle>{sonDptos ? 'Borrando Departamentos' : 'Borrando Departamento'}</DialogTitle>
                                    <DialogContent dividers>
                                        <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    {sonDptos ? '¿Quiere borrar los departamentos seleccionados?' : '¿Quiere borrar el departamento seleccionado?'}
                                                </Grid>
                                                <List>
                                                    {dptos.map(id => (
                                                        <ListItem key={'dpto' + dptos[id]} >
                                                            <ListItemIcon><HomeRoundedIcon></HomeRoundedIcon></ListItemIcon>
                                                            <ListItemText>{`ID:  ${id}`}</ListItemText>
                                                        </ListItem>))}
                                                </List>
                                                <Grid item xs={12}>

                                                    <div style={{ marginTop: '10px', marginLeft: '5px' }}>
                                                        <Button variant="contained" onClick={borrar} sx={{ marginRight: '5px' }}>{"Aceptar"}</Button>
                                                        <Button variant="outlined" onClick={closeDeleteForm}>{"Cancelar"}</Button>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </DialogContent>
                                </Dialog>
                            </Fragment>
                        )
                    }
                    const NuevoDptoForm = (props) => {
                        const [errores, setErrores] = useState([]);
                        const handleDptoChange = (value, propiedad) => {
                            let newDpto = { ...dpto };
                            if (propiedad === 1) { newDpto = { ...newDpto, claseContratoId: parseInt(value) } }
                            setDpto(newDpto);
                        }
                        function handleSubmitDpto() {
                            let estamosEditando = props.dpto.departamentoId;
                            setErrores([]);
                            let huboError = false; //FIX: setState es una funcion asincronica, no se puede usar como condicion la logintud del array errores

                            function isEmpty(obj) {
                                for (var key in obj) {
                                    if (obj[key] !== "" && obj[key] !== undefined) {
                                        return false;
                                    }
                                }
                                return true;
                            }
                            if (dpto.claseContratoId === undefined || dpto.claseContratoId === '') {
                                setErrores([...errores, 'Debe completar la clase de contrato']);
                                huboError = true;
                            }
                            if (huboError) return;
                            if (creando === false) {
                                dpto.departamentoId = props.dpto.departamentoId
                                editDepartamento(dpto).unwrap()
                                    .then(console.log)
                                    .catch(console.log);
                            } else {
                                removeEmpty(dpto);
                                addDepartamento(dpto).unwrap()
                                    .then(console.log)
                                    .catch(console.log);
                            }
                        }
                        return (
                            <Fragment>

                                <Dialog
                                    open={showNuevoDptoForm}
                                    onClose={closeForm}
                                    maxWidth='md'
                                >
                                    <DialogTitle>{creando ? 'Crear nuevo Departamento' : `Editar Departamento ID: ${props.dpto.departamentoId}`}</DialogTitle>
                                    <DialogContent dividers>
                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', with: 900 }} >
                                            <div>
                                                <FormContainer defaultValues={{ ...dpto }} >
                                                    <Grid container spacing={1} dividers="true" key={'dpto' + dpto.departamentoId} >
                                                        <Grid item xs={1} style={{ 'paddingTop': '20px', 'marginRight': '50px' }}>
                                                            <List>
                                                                <ListItem>
                                                                    <ListItemIcon style={{ 'marginRight': '0px' }}><HomeRoundedIcon></HomeRoundedIcon></ListItemIcon>
                                                                    <ListItemText>{creando ? `Nuevo Dpto` : `ID:  ${dpto.departamentoId}`}</ListItemText>
                                                                </ListItem>
                                                            </List>
                                                        </Grid>
                                                        <Grid item xs={3} style={{ 'paddingTop': '28px', 'marginLeft': '15px' }}>
                                                            <SelectElement
                                                                sx={{ width: '100%' }}
                                                                label="Clase Contrato"
                                                                name={'claseContratoId'}
                                                                value={dpto.claseContratoId}
                                                                required
                                                                options={getOptionsClasesContratos()}
                                                                onChange={(value) => { handleDptoChange(value, 1) }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={2} style={{ 'paddingTop': '20px' }}>
                                                            <FormControl sx={{ m: 1 }} variant="outlined">
                                                                <OutlinedInput
                                                                    value={dpto.m2}
                                                                    onChange={e => setDpto({ ...dpto, m2: parseInt(e.target.value) })}
                                                                    id="outlined-adornment-weight"
                                                                    type="number"
                                                                />
                                                                <FormHelperText id="outlined-weight-helper-text">m2</FormHelperText>
                                                            </FormControl>
                                                        </Grid>
                                                        <Grid item xs={2} style={{ 'paddingTop': '20px' }}>
                                                            <FormControl sx={{ m: 1 }} variant="outlined">
                                                                <OutlinedInput
                                                                    value={dpto.piso}
                                                                    onChange={e => setDpto({ ...dpto, piso: parseInt(e.target.value) })}
                                                                    id="outlined-adornment-weight"
                                                                    type="number"
                                                                />
                                                                <FormHelperText id="outlined-weight-helper-text">Piso</FormHelperText>
                                                            </FormControl>
                                                        </Grid>
                                                        <Grid item xs={2} style={{ 'paddingTop': '20px' }}>
                                                            <FormControl sx={{ m: 1 }} variant="outlined">
                                                                <OutlinedInput
                                                                    value={dpto.uniFuncional}
                                                                    onChange={e => setDpto({ ...dpto, uniFuncional: e.target.value.toString() })}
                                                                    id="outlined-adornment-weight"
                                                                    type="string"
                                                                />
                                                                <FormHelperText id="outlined-weight-helper-text">U.F.</FormHelperText>
                                                            </FormControl>
                                                        </Grid>
                                                    </Grid>
                                                </FormContainer>
                                            </div>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} sx={{ color: 'error.main' }}>
                                                    {errores.length > 0 && errores.map((error, i) => <p style={{ marginLeft: '8px' }} key={'err' + i}>- {error}</p>)}
                                                </Grid>

                                                <Grid item xs={12}>
                                                    <div style={{ marginTop: '10px', marginLeft: '5px' }}>
                                                        <Button variant="contained" onClick={handleSubmitDpto} sx={{ marginRight: '5px' }}>{"Aceptar"}</Button>
                                                        <Button variant="outlined" onClick={closeForm}>{"Cancelar"}</Button>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </DialogContent>
                                </Dialog>
                            </Fragment>
                        )
                    }
                    return (
                        <Fragment>
                            <IconButton className="mb-3" variant="contained" color='primary' onClick={handleAddDpto}><AddIcon /></IconButton>
                            <IconButton className="mb-3" variant="contained" disabled={selectedRowsDptos.length !== 1} color='info' onClick={handleEditDpto}><EditIcon /></IconButton>
                            <IconButton className="mb-3" variant="contained" disabled={selectedRowsDptos.length === 0} color='danger' onClick={handleDeleteSubmitDpto}><DeleteIcon /></IconButton>
                            <NuevoDptoForm dpto={dpto}></NuevoDptoForm>
                            <BorrarDptoForm dpto={dpto}></BorrarDptoForm>
                        </Fragment>
                    )
                }
                return (

                    <Dialog
                        open={showBuildingMoreDetail}
                        onClose={closeMoreDetail}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        fullWidth={true}
                        maxWidth='lg'
                    >
                        <DialogTitle>{`Departamentos del edificio ID: ${edificioId}`}</DialogTitle>
                        <DialogContent dividers>
                            <Box sx={{ flexGrow: 1, padding: '2rem', height: 600, width: '100%', borderBottom: 1, borderColor: 'divider' }}>
                                <DptosBtnBar></DptosBtnBar>
                                <DataGrid
                                    getRowId={r => r.departamentoId}
                                    initialState={{
                                        sorting: {
                                            sortModel: [{ field: 'ID', sort: 'desc' }],
                                        },
                                    }}
                                    rows={rowsDptos}
                                    columns={columnsDepartamentos}
                                    pageSize={100}
                                    rowsPerPageOptions={[5]}
                                    checkboxSelection
                                    // disableSelectionOnClick
                                    experimentalFeatures={{ newEditingApi: true }}
                                    onSelectionModelChange={setSelectedRowsDptos}
                                    components={{
                                        Toolbar: () => {
                                            return <GridToolbarContainer><GridToolbarColumnsButton></GridToolbarColumnsButton> <GridToolbarFilterButton></GridToolbarFilterButton> <GridToolbarDensitySelector></GridToolbarDensitySelector>
                                                {currentUser?.permisos?.includes('export-data') ? <GridToolbarExport></GridToolbarExport>
                                                    : ''}</GridToolbarContainer>
                                        }
                                    }}
                                    componentsProps={{
                                        toolbar: {
                                            showQuickFilter: true,
                                            quickFilterProps: { debounceMs: 500 },
                                        },
                                    }}
                                />
                            </Box>
                        </DialogContent>
                    </Dialog >
                )
            };
            return (
                <Fragment>
                    <IconButton className="mb-3" variant="contained" color='primary' onClick={handleAdd}><AddIcon /></IconButton>
                    <IconButton className="mb-3" variant="contained" disabled={selectedRows.length !== 1} color='info' onClick={handleEdit}><EditIcon /></IconButton>
                    <IconButton className="mb-3" variant="contained" disabled={selectedRows.length === 0} color='danger' onClick={handleDeleteSubmit}><DeleteIcon /></IconButton>
                    <NuevoEdificioForm edificio={estamosEditando}></NuevoEdificioForm>
                    <BorrarEdificioForm edificio={estamosBorrando}></BorrarEdificioForm>
                    <BuildingMoreDetailsModal edificio={buildingMoreDetail}></BuildingMoreDetailsModal>
                </Fragment>
            );
        };
        return (
            <Fragment>
                <BtnBar></BtnBar>
                <Box sx={{ height: 600, width: '100%' }}>
                    <DataGrid
                        getRowId={r => r.edificioId}
                        initialState={{
                            sorting: {
                                sortModel: [{ field: 'ID', sort: 'desc' }],
                            },
                        }}
                        rows={rows}
                        columns={columns}
                        pageSize={100}
                        rowsPerPageOptions={[6]}
                        checkboxSelection
                        //disableSelectionOnClick
                        experimentalFeatures={{ newEditingApi: true }}
                        onSelectionModelChange={setSelectedRows}
                        components={{
                            Toolbar: () => {
                                return <GridToolbarContainer><GridToolbarColumnsButton></GridToolbarColumnsButton> <GridToolbarFilterButton></GridToolbarFilterButton> <GridToolbarDensitySelector></GridToolbarDensitySelector>
                                    {currentUser?.permisos?.includes('export-data') ? <GridToolbarExport></GridToolbarExport>
                                        : ''}</GridToolbarContainer>
                            }
                        }}
                        componentsProps={{
                            toolbar: {
                                showQuickFilter: true,
                                quickFilterProps: { debounceMs: 500 },
                            },
                        }}
                    />
                </Box>
            </Fragment>
        );


    };
    return (
        <Fragment>
            <Header></Header>
            <EdificiosTable></EdificiosTable>
        </Fragment>
    )

};